export const disabledClassName = 'disabled';
export const selectedClassName = 'selected';
